import * as React from "react";

import { toast } from "@/components/ui/use-toast";
import { isRunningStandalonePwa } from "@/utils/pwa";

const REMINDER_STORAGE_KEY = "pwa-notification-reminder-shown";

const hasNotificationPermission = () => {
  if (typeof window === "undefined") {
    return false;
  }

  if (!("Notification" in window)) {
    return false;
  }

  return Notification.permission === "granted";
};

const remindToEnableNotifications = () => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(REMINDER_STORAGE_KEY, "true");
  } catch (error) {
    console.warn("No se pudo registrar el recordatorio de notificaciones PWA", error);
  }

  toast({
    title: "Activa las notificaciones push",
    description:
      "Para recibir avisos en tu dispositivo, activa las notificaciones push en tu perfil.",
  });
};

const shouldRemind = () => {
  if (typeof window === "undefined") {
    return false;
  }

  if (!("Notification" in window)) {
    return false;
  }

  if (hasNotificationPermission()) {
    return false;
  }

  try {
    return window.localStorage.getItem(REMINDER_STORAGE_KEY) !== "true";
  } catch (error) {
    console.warn("No se pudo comprobar el recordatorio de notificaciones PWA", error);
    return true;
  }
};

export function PwaNotificationReminder(): null {
  const hasCheckedRef = React.useRef(false);

  React.useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const maybeRemind = () => {
      if (!shouldRemind()) {
        return;
      }

      remindToEnableNotifications();
    };

    const handleAppInstalled = () => {
      hasCheckedRef.current = true;
      maybeRemind();
    };

    window.addEventListener("appinstalled", handleAppInstalled);

    if (isRunningStandalonePwa() && !hasCheckedRef.current) {
      hasCheckedRef.current = true;
      maybeRemind();
    }

    return () => {
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  return null;
}

export default PwaNotificationReminder;
